import { EnvConfig, EnvVar } from '~/types';
import { getEnvVar } from '~/utils';

export const ENV_CONFIG: EnvConfig = {
  [EnvVar.NEXT_PUBLIC_API_BASE_URL]: getEnvVar(EnvVar.NEXT_PUBLIC_API_BASE_URL),
  [EnvVar.NEXT_PUBLIC_BASE_NEXT_URL]: getEnvVar(
    EnvVar.NEXT_PUBLIC_BASE_NEXT_URL
  ),
  [EnvVar.NEXT_PUBLIC_FILE_UPLOAD_BASE_URL]: getEnvVar(
    EnvVar.NEXT_PUBLIC_FILE_UPLOAD_BASE_URL
  ),
  [EnvVar.NEXT_PUBLIC_PUSHER_CLUSTER]: getEnvVar(
    EnvVar.NEXT_PUBLIC_PUSHER_CLUSTER
  ),
  [EnvVar.NEXT_PUBLIC_PUSHER_KEY]: getEnvVar(EnvVar.NEXT_PUBLIC_PUSHER_KEY),
  [EnvVar.NEXT_PUBLIC_SLACK_CLIENT_ID]: getEnvVar(
    EnvVar.NEXT_PUBLIC_SLACK_CLIENT_ID
  ),
  [EnvVar.NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN]: getEnvVar(
    EnvVar.NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN
  ),
  [EnvVar.NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL]: getEnvVar(
    EnvVar.NEXT_PUBLIC_UNLEASH_FRONTEND_API_URL
  )
};
